import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="h-px w-10 bg-gold/60" />
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-gold">
      {children}
    </span>
  </div>
);
